import { axiosClient } from '@/lib/axiosClient';

export interface CertificateTemplate {
  id: number;
  name: string;
  type: 'convention' | 'conference' | 'mainroom';
  conference_id: number | null;
  certificate_type_id: number | null;
  background_image: string;
  background_image_url: string | null;
  pos_nomor_surat_top: number;
  pos_sebagai_top: number;
  pos_nama_peserta_top: number;
  officials_top_offset: number | null;
  certificate_number_format: string | null;
  certificate_date: string | null;
  certificate_title: string | null;
  text_top: string | null;
  text_middle: string | null;
  text_bottom: string | null;
  event_name: string | null;
  event_date_text: string | null;
  event_venue: string | null;
  is_active: boolean;
  period_id: number;
  period?: {
    period_id: number;
    name: string;
  };
  conference?: {
    conference_id: number;
    name: string;
  };
  certificate_type?: {
    id: number;
    name: string;
    code: string;
  };
}

export const certificateTemplateService = {
  getAll: async (period_id: string = 'all') => {
    const response = await axiosClient.get(`/private/certificate-templates?period_id=${period_id}`);
    return response.data as CertificateTemplate[];
  },

  create: async (data: FormData) => {
    const response = await axiosClient.post('/private/certificate-templates', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  update: async (id: number, data: FormData) => {
    // using POST because PHP doesn't easily parse PUT multipart/form-data
    const response = await axiosClient.post(`/private/certificate-templates/${id}`, data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  delete: async (id: number) => {
    const response = await axiosClient.delete(`/private/certificate-templates/${id}`);
    return response.data;
  },
};
